import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";
import { FieldValues } from "react-hook-form";

interface mutateProps {
  communityId: string | number;
  fiscalYear: string | number;
  data: FieldValues
}

const mutateReopenYear = async ({ communityId, fiscalYear, data }: mutateProps) => {
  return await axiosAuth.post(
    `${FISCAL_YEAR_API(communityId)}/${fiscalYear}/reopen`,
    data
  );
};

const useReopenYearMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateReopenYear,
    ...queryParams,
  });

export default useReopenYearMutation;
